import { Controller } from "@hotwired/stimulus";

// Sticky header: flags the header once the page has scrolled past the top, so
// it can compact itself and lift off the content. Styling lives in the markup
// via Tailwind's data-scrolled: variant.
const THRESHOLD = 8;

export default class extends Controller {
  connect() {
    this.onScroll = () => {
      const scrolled = window.scrollY > THRESHOLD;
      if (scrolled === this.scrolled) return;
      this.scrolled = scrolled;
      this.element.toggleAttribute("data-scrolled", scrolled);
    };
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
  }
}
